import { cn } from '@/shared/styles/utils.ts';
import { useStopScroll } from '@/shared/hooks/useStopScroll.ts';
import { footerDocuments } from '@/widgets/Footer/model/documents.tsx';
import { Documents } from '@/widgets/Documents';
import { Contacts } from '@/shared/ui/Contacts';
import { Copyright } from '@/shared/ui/Copyright';
import { LangSwitcher } from '@/features/LangSwitcher';
import { CabinetLinkButton } from '@/shared/ui/CabinetLinkButton';

interface Props {
  show: boolean;
  onClose: () => void;
}

export default function Drawer({ show, onClose }: Props) {
  useStopScroll(show);

  const onCabinetClick = () => {
    onClose();
  };

  return (
    <div
      className={cn(
        'flex-col-gap-6 bg-light fixed top-[var(--header-height)] right-0 bottom-0 left-0 z-50 justify-between px-4 pt-6 pb-4 transition-transform',
        show ? 'translate-x-0' : 'translate-x-[100%]'
      )}
    >
      <div className="flex-col-gap-6">
        <Documents data={footerDocuments} />
        <CabinetLinkButton to="/cabinet" onClick={onCabinetClick} />
      </div>
      <div className="flex-col-gap-6 justify-between">
        <Contacts />
        <div className="flex-col-gap-4">
          <div className="flex">
            <LangSwitcher />
          </div>
          <Copyright />
        </div>
      </div>
    </div>
  );
}
